<template>
  <div class="loader_wrapper">
    <div>
      <div class="cssload-wrap">
        <div class="cssload-cssload-spinner"></div>
      </div>
      <div id="loader-title">
        {{resource.str_loader}}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['resource'])
  },
  name: 'Loader'
}
</script>
<style scoped>
/* @import url('https://fonts.googleapis.com/css?family=Nunito'); */
.loader_wrapper {
  position: absolute;
  height: 100%;
  width: 100%;
  /* background-color: rgba(0, 0, 0, 0.5); */
  background: linear-gradient(to bottom, rgba(0,0,0,0.5) 0%,rgba(0,0,0,0.95) 100%);
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cssload-wrap {
	display: flex;
	box-pack: center;
	justify-content: center;
	box-align: center;
	align-items: center;
	perspective: 210px;
	height: 100px;
	overflow: hidden;
}

.cssload-cssload-spinner {
	position: relative;
	transform-style: preserve-3d;
	animation: cssload-wobble 3.7895s ease-in-out infinite;
}
.cssload-cssload-spinner:before, .cssload-cssload-spinner:after {
	display: block;
	content: "";
	width: 30px;
	height: 30px;
	border: 15px solid;
	border-radius: 50%;
	animation: cssload-spin 1.425s ease-in-out infinite both reverse;
}
.cssload-cssload-spinner:before {
	border-color: #007aff;
	position: absolute;
}
.cssload-cssload-spinner:after {
	border-color: #333333;
	animation-delay: -0.7075s;
}

@keyframes cssload-wobble {
	0%, 100% {
		transform: rotateX(8.75deg) rotateY(35deg);
	}
	50% {
		transform: rotateX(35deg) rotateY(-35deg) rotate(180deg);
	}
}

@keyframes cssload-spin {
	0%, 100% {
		transform: translateZ(26px) rotateX(14deg);
	}
	33% {
		transform: translateZ(-26px) scale(0.4);
	}
	66% {
		transform: translateZ(-26px);
	}
}


/* -----------------------------------------------------------------
   Loader title animation
   ----------------------------------------------------------------- */
#loader-title {
	font-family: Nunito;
  text-align: center;
  font-size: 20px;
  letter-spacing: 7px;
  font-weight: 800;
  color: #ffffff;
  animation: loader-title-animation 1.425s infinite;
}
@font-face {
  font-family: 'Nunito';
 font-style: normal;
 font-weight: 400;
 src:local("Nunito") url('/fonts/nunito/Nunito1.woff2') format('woff2');
}
/* Standard syntax */
@keyframes loader-title-animation {
    50% {letter-spacing: 10px; font-size: 23px;}
}
</style>



// WEBPACK FOOTER //
// src/components/Shared/Loader.vue